/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  LeverageGetHistoricalInterestRatesOptions,
  LeverageGetHistoricalInterestRatesResponses,
} from '../types/LeverageGetHistoricalInterestRates'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get historical leverage borrowing and lending yields for a specific asset
 * {@link /v1/leverage/interest_rate/:asset_id/historical}
 */
export function leverageGetHistoricalInterestRates<ThrowOnError extends boolean = true>(
  options: Options<LeverageGetHistoricalInterestRatesOptions, ThrowOnError>,
): Unwrappable<RequestResult<LeverageGetHistoricalInterestRatesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/leverage/interest_rate/{asset_id}/historical',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<LeverageGetHistoricalInterestRatesResponses, ThrowOnError>>,
  )
}
